import { useQuery } from "@tanstack/react-query";

import { getTrophyCaseData } from "./getTrophyCaseData";

export const useTrophyCaseData = () => {
    const { data, isLoading, isError } = useQuery({
        queryKey: ["TrophyCaseData"],
        queryFn: async () => getTrophyCaseData(),
        retry: 1,
    });
    return { data, isLoading, isError };
};
